module.exports = __webpack_public_path__ + "assets/35495e4b4640b223273c60b120f73e5c.json";